import { currencyFormat } from '@/utils/currencyFormat'
import { getMonto, getMontoConsola } from '@/utils/getMonto'
import { Checkbox, Input, Link, Select, SelectItem } from '@nextui-org/react'
import { motion } from 'framer-motion'
import React, { CSSProperties, useEffect, useState } from 'react'
import { useFormularioClienteContext } from '../hooks/useFormularioClienteContext'
import { webApiService } from '@/services'
import { useLocation, useParams } from 'react-router-dom'
import { enqueueSnackbar } from 'notistack'
import { IConfigSeller } from '@/models/configSeller'
import { useSelector } from 'react-redux'
import { IUser } from '@/models/user.model'
import { FormularioClienteContextType } from '../context/FormularioClienteContext'

const StepThree: React.FC = () => {
  const { ctx, saveCtx } = useFormularioClienteContext() as FormularioClienteContextType
  const [data, setData] = useState<{ storeList: any[], loading: boolean }>({ storeList: [], loading: false })
  const userState = useSelector((store: { user: IUser }) => store.user)
  const location = useLocation()
  const { slug } = useParams()
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isConsolaFalabella = configSeller.config.s3.FOLDER_APP === 'ti_falabella' && ctx.data.sbu.id_sbu === 12
  console.log('🚀 ~ StepThree ~ isConsolaFalabella:', isConsolaFalabella)

  let isInIframe = false

  try {
    isInIframe = window.self !== window.top
  } catch (e) {
    isInIframe = true // No se puede acceder a window.top, asumimos que está en iframe
  }

  const loadData = async () => {
    setData({ ...data, loading: true })
    webApiService.getAllStoreBySeller(String(slug)).then(res => {
      if (res.success) {
        setData({ storeList: res.data, loading: false })
      }
    }).catch((error) => {
      console.log(error)
      enqueueSnackbar(error.message, { variant: 'error' })
      setData({ ...data, loading: false })
    })
  }

  const getCampaign = () => {
    webApiService.activeContribution({ seller: String(slug), idSbu: ctx.data.sbu.id_sbu, idBrand: ctx.data.brand.id_brand, idModel: ctx.data.model.id_model }).then(res => {
      if (res.data !== null) {
        saveCtx({ ...ctx, data: { ...ctx.data, campaign: res.data } })
      }
    }).catch((error: any) => {
      console.log(error)
      enqueueSnackbar(error.message, { variant: 'error' })
    })
  }

  useEffect(() => {
    if (configSeller.config.s3.FOLDER_APP === 'ti_coppel' || configSeller.config.s3.FOLDER_APP === 'ti_macstore') loadData()
    if (configSeller.config.permisos.ENABLE_CONTRIBUTION === 1) getCampaign()
    return () => setData({ loading: false, storeList: [] })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <motion.div
      initial={{ y: 10, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: -10, opacity: 0 }}
      transition={{ duration: 0.3 }}
      className='py-6'
    >
      <h3 className='mb-2 mt-4 text-center font-bold'>Verifica tu equipo</h3>
      <div className='container mb-3'>
        <div className=' border-black border rounded grid grid-cols-2'>
          <div className='p-4 border-r'>
            <h5 className='font-bold text-xl'>{ctx.data.sbu.name}</h5>
            {
                ctx.data.sbu.id_sbu !== 2
                  ? (<p className='mb-0'>{ctx.data.model.model} - {ctx.data.capacity.capacity}</p>)
                  // : (ctx.data.sbu.id_sbu === 2 && ctx.data.brand.id_brand === 2)
                  //     ? (<p className='mb-0'>{ctx.data.model.model}</p>)
                  : (ctx.data.sbu.id_sbu === 2 && ctx.data.brand.id_brand === 1 && ctx.data.model.capacity === 0)
                      ? (<p className='mb-0'>{ctx.data.model.model}</p>)
                      : (ctx.data.sbu.id_sbu === 2 && ctx.data.brand.id_brand === 1 && ctx.data.model.capacity !== 0)
                          ? (<p className='mb-0'>{ctx.data.model.model} {ctx.data.cpu.name ? `- ${ctx.data.cpu.name}` : null}  - {ctx.data.screen.screen} - {ctx.data.ram.ram} ram - {ctx.data.capacity.capacity}</p>)
                          : (<p className='mb-0'>{ctx.data.cpu.name} - {ctx.data.screen.screen} - {ctx.data.ram.ram} ram - {ctx.data.capacity.capacity}</p>)
              }
          </div>
          <div className='p-4'>
            <p className='font-bold mb-1 text-end'>Monto de descuento</p>
            <p hidden={isConsolaFalabella} className='h5 font-black text-end'>{currencyFormat(getMonto(ctx.data, String(slug)), import.meta.env.VITE_COUNTRY)}</p>
            <p hidden={!isConsolaFalabella} className='h5 font-black text-end'>{currencyFormat(getMontoConsola(ctx.data, String(slug), Number(ctx.data.extraControls)), import.meta.env.VITE_COUNTRY)}</p>
            {
              ctx.data.campaign !== null && configSeller.config.permisos.ENABLE_CONTRIBUTION === 1
                ? (
                  <>
                    <div className='text-end' hidden={ctx.data.campaign === null || ctx.data.campaign === undefined}>
                      Monto extra campaña {ctx.data.campaign !== null ? `(${ctx.data.campaign.name})` : ''}: <span className='h5 font-black text-end'>{ctx.data.campaign !== null ? currencyFormat(ctx.data.campaign.amount, import.meta.env.VITE_COUNTRY) : currencyFormat(0, import.meta.env.VITE_COUNTRY)}</span>
                    </div>
                    <div className='text-end' hidden={ctx.data.campaign === null || ctx.data.campaign === undefined}>
                      Total : <span className='h5 font-black text-end'>{currencyFormat(Number(ctx.data.campaign.amount) + (isConsolaFalabella ? getMontoConsola(ctx.data, String(slug), Number(ctx.data.extraControls)) : getMonto(ctx.data, String(slug))), import.meta.env.VITE_COUNTRY)}</span>
                    </div>
                  </>
                  )
                : null
            }
          </div>
        </div>
      </div>
      <div className='max-w-[600px] mx-auto'>
        <div className='grid grid-cols-2 gap-4'>
          <div>
            <Input
              type='text'
              variant='bordered'
              label='Nombre'
              value={ctx.data.name}
              fullWidth
              errorMessage={ctx.validation && ctx.data.name.trim() === '' ? 'Debe ingresar su nombre' : ''}
              isInvalid={ctx.validation && ctx.data.name.trim() === ''}
              autoComplete='off'
              onChange={(e) => saveCtx({ ...ctx, data: { ...ctx.data, name: e.target.value } })}
            />
          </div>
          <div>
            <Input
              type='text'
              variant='bordered'
              label='Apellido'
              value={ctx.data.lastname}
              fullWidth
              errorMessage={ctx.validation && ctx.data.lastname.trim() === '' ? 'Debe ingresar su apellido' : ''}
              isInvalid={ctx.validation && ctx.data.lastname.trim() === ''}
              autoComplete='off'
              onChange={(e) => saveCtx({ ...ctx, data: { ...ctx.data, lastname: e.target.value } })}
            />
          </div>

          <div className='col-span-2'>
            <Input
              type='email'
              variant='bordered'
              label='Correo electronico'
              value={ctx.data.email}
              fullWidth
              errorMessage={ctx.validation && ctx.data.email.trim() !== '' && !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(ctx.data.email) ? 'Debe ingresar un correo válido' : ''}
              isInvalid={ctx.validation && ctx.data.email.trim() !== '' && !/^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/.test(ctx.data.email)}
              autoComplete='off'
              onBlur={() => saveCtx({ ...ctx, validation: ctx.data.email.trim() !== '' })}
              onChange={(e) => saveCtx({ ...ctx, data: { ...ctx.data, email: String(e.target.value) } })}
            />
          </div>
          {
            (configSeller.config.s3.FOLDER_APP === 'ti_coppel' || (configSeller.config.s3.FOLDER_APP === 'ti_macstore' && userState.id === 0)) && !isInIframe &&
              <div className='col-span-2'>
                <Select
                  variant='bordered'
                  size='lg'
                  aria-label='Select'
                  scrollShadowProps={{
                    isEnabled: true
                  }}
                  className='w-full'
                  placeholder='Seleccione una tienda'
                  isLoading={data.loading}
                  isDisabled={data.loading}
                  selectedKeys={ctx.data.id_store === 0 ? undefined : [String(ctx.data.id_store)]}
                  onChange={(e) => { saveCtx({ ...ctx, data: { ...ctx.data, id_store: Number(e.target.value) } }) }}
                >
                  {data.storeList.map((s) => (
                    <SelectItem key={String(s.id)} textValue={`${slug === 'coppel' ? s.seller_store_number + ' - ' : ''}${s.store.toUpperCase()}`}>
                      {slug === 'coppel' ? s.seller_store_number + ' - ' : ''}{s.store.toUpperCase()}
                    </SelectItem>
                  ))}
                </Select>
              </div>
          }
          {(
            (configSeller.config.s3.FOLDER_APP === 'ti_macstore' && userState.id === 0) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_wom' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_oppo' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_falabella' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe_rom' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_falabella_pe' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_conecta_peru' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_claro' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_samsung_mx' && location.pathname.includes('backoffice')) ||
            (configSeller.config.s3.FOLDER_APP === 'ti_motorola' && location.pathname.includes('backoffice'))) &&
            !isInIframe &&
              <>
                <div className='col-span-2'>
                  <h3 className='mb-2 mt-4 text-center font-bold'>Ingrese datos VENDEDOR de la tienda</h3>
                </div>
                <div>
                  <Input
                    type='text'
                    variant='bordered'
                    label='Nombre del vendedor'
                    value={ctx.data.executiveName}
                    fullWidth
                  // errorMessage={ctx.validation && ctx.data.name.trim() === '' ? 'Debe ingresar su nombre' : ''}
                  // isInvalid={ctx.validation && ctx.data.name.trim() === ''}
                    autoComplete='off'
                    onChange={(e) => saveCtx({ ...ctx, data: { ...ctx.data, executiveName: e.target.value } })}
                  />
                </div>
                <div>
                  <Input
                    type='text'
                    variant='bordered'
                    label='Apellido del vendedor'
                    value={ctx.data.executiveLastname}
                    fullWidth
                  // errorMessage={ctx.validation && ctx.data.lastname.trim() === '' ? 'Debe ingresar su apellido' : ''}
                  // isInvalid={ctx.validation && ctx.data.lastname.trim() === ''}
                    autoComplete='off'
                    onChange={(e) => saveCtx({ ...ctx, data: { ...ctx.data, executiveLastname: e.target.value } })}
                  />
                </div>
                <div className='col-span-2'>
                  <Input
                    type='text'
                    variant='bordered'
                    label={`${import.meta.env.VITE_LABEL_RUT} del vendedor`}
                    value={ctx.data.executiveRut}
                    fullWidth
                  // errorMessage={ctx.validation && ctx.data.lastname.trim() === '' ? 'Debe ingresar su apellido' : ''}
                  // isInvalid={ctx.validation && ctx.data.lastname.trim() === ''}
                    autoComplete='off'
                    onChange={(e) => saveCtx({ ...ctx, data: { ...ctx.data, executiveRut: e.target.value } })}
                  />
                </div>
              </>}
          <div hidden={ctx.steps.current === 1 || ctx.steps.current === 0} className='col-span-2'>
            {
            configSeller.config.optin !== undefined && configSeller.config.optin.length > 0
              ? configSeller.config.optin.map((optin: any) => (
                <div key={optin.id} className='flex items-center my-4'>
                  <Checkbox
                    style={{ '--seller-color': `${configSeller.config.color}` } as CSSProperties}
                    classNames={{ wrapper: 'after:bg-[var(--seller-color)]' }}
                    size='sm'
                    isSelected={ctx.data.optins.find(o => o.id === optin.id)?.checked === undefined ? false : ctx.data.optins.find(o => o.id === optin.id)?.checked}
                    onChange={(e) => {
                      console.log('-e.target.checked-e.target.checked', e.target.checked, ctx.data.optins.find(o => o.id === optin.id)?.checked)
                      if (e.target.checked) { saveCtx({ ...ctx, data: { ...ctx.data, optins: [...ctx.data.optins, { id: optin.id, checked: e.target.checked }] } }) } else { saveCtx({ ...ctx, data: { ...ctx.data, optins: [...ctx.data.optins.filter(op => op.id !== optin.id)] } }) }
                    }}
                  >{optin.texto} <Link href={optin.link} className='text-sm' target='_blank' rel='noreferrer'>Click aquí</Link>
                  </Checkbox>
                </div>
              ))
              : null
          }
          </div>
        </div>
      </div>
    </motion.div>
  )
}

export default StepThree
